import React, { useEffect, useMemo, useState } from 'react';
import { Button, Checkbox, Col, Modal, Row, Select, Space, Spin, Table, Tabs, Tooltip, message, Divider } from 'antd';
import { connect, useDispatch, useSelector} from 'react-redux';
import { ze } from 'utils/zhEn';
import RestHelper from 'utils/RestHelper';
import { getIssueDetailUrlPrefix } from 'utils/helper';
import { Link } from 'react-router-dom';
import CsTabs from 'components/antd-extension/CsTabs';
import SimilarIssues from 'components/exception/issue/SimilarIssues/SimilarIssues';
import IssueRegroup from 'components/exception/issue/IssueRegroup';
import { CsNewTabs } from 'components/antd-extension/CsNewTabs';

const TAB_VALUE_SUB_ISSUES = 'SUB_ISSUES';
const TAB_VALUE_SIMILAR_ISSUES = 'SIMILAR_ISSUES';

const AiIssueGrouping = ({
  reduxState,
  appId,
  pid,
  path,
  issueId,
  issue,
  exceptionType,
  exceptionCategory,
}) => {
  const [tabValue, setTabValue] = useState(TAB_VALUE_SUB_ISSUES);

  const subIssuesDom = tabValue === TAB_VALUE_SUB_ISSUES && <IssueRegroup
    key='subproblem-analysis'
    appId={appId}
    platformId={pid}
    issueHash={issueId}
    issue={issue}
    exceptionType={exceptionType}
    path={path}
    isFromSubIssueTab={true}
  />;

  const res = <div>
    <div style={{ marginBottom: '16px', display: 'flex' }}>
      <CsNewTabs
        value={tabValue}
        onChange={(v)=>{setTabValue(v)}}
        options={[
          {
            label: ze('子分类','Sub Issues'),
            value: TAB_VALUE_SUB_ISSUES,
          },
          {
            label: ze('相似问题','Similar Issues'),
            value: TAB_VALUE_SIMILAR_ISSUES,
          },
        ]}
      />
    </div>
    { tabValue === TAB_VALUE_SUB_ISSUES && subIssuesDom }
    { tabValue === TAB_VALUE_SIMILAR_ISSUES && <SimilarIssues
      appId={appId}
      pid={pid}
      issueId={issueId}
      exceptionCategory={exceptionCategory}
    /> }
  </div>;

  return res;
};

const mapStateToProps = state => ({
  reduxState: state,
});

export default connect(mapStateToProps)(AiIssueGrouping);
